import Breakpoint from "./Breakpoint"
import React from "react";

export default function Responsive(props) {
  return (
    <Breakpoint name={props.name}>
      {props.children}
    </Breakpoint>
  );
 }


// WEBPACK FOOTER //
// ./src/component/Responsive/Responsive.jsx